module.exports = __webpack_public_path__ + "static/media/logo_veloregio.1cd336cd.png";